import { createContext } from 'react';
import { defaultAssociationModalContextProps } from './constants';
export const AssociationModalPropsContext = /*#__PURE__*/createContext(defaultAssociationModalContextProps);